import { Text } from '@qualio/ui-components';
import styled from 'styled-components';

export const StyledInputLabel = styled(Text)<{ isError?: boolean }>`
  margin-bottom: ${(props: any) => props.theme.space[4]} !important;
  ${({ isError, theme }) => isError && `color: ${theme.colors.error.text}`}
`;
